import React, { useEffect, useState } from "react";
import "./Nav.css";
import SearchIcon from '@material-ui/icons/Search'
import { useHistory } from 'react-router-dom'
import { useStateValue } from './StateProvider'
import { actionTypes } from './reducer'

function Nav() {
  const [show, handleShow] = useState(false);
  

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 150) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll");
    };
  }, []);

  
  

  return (
    <div className={`nav ${show && "nav__black"}`}>
      <img
        className="nav__logo"
        src="https://upload.wikimedia.org/wikipedia/commons/0/0f/Logo_Netflix.png"
        alt="Netflix Logo"
      />

      <div className="nav__search">
        <input type="text" className="nav__searchInput" />
        <SearchIcon className="nav__searchIcon" />
      </div>

    </div>
  );
}

export default Nav;
